import { DoubleText, SliceConnectButton } from ".."
import { useAccount } from "wagmi"

const ConnectBlock = ({ children }) => {
  const { connector } = useAccount()
  return connector ? (
    children
  ) : (
    <>
      <div className="flex flex-col items-center py-6 mx-auto max-w-screen-xs">
        <DoubleText
          inactive
          logoText="Connect your wallet"
          size="text-4xl sm:text-5xl"
        />
        <p className="py-10 text-lg">
          You need to connect your wallet to view this page.
        </p>
        <SliceConnectButton />
      </div>
    </>
  )
}

export default ConnectBlock
